
import { useEffect, useState } from 'react';
import * as React from 'react';
import { PopupModal } from 'react-calendly';

export function CalendlyModal({
  open,
  setOpen,
}: {
  open: boolean;
  setOpen: (open: boolean) => void;
}) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!mounted) {
      setMounted(true);
    }
  }, []);

  if (!mounted) return null;

  return (
    <PopupModal
      open={open}
      onModalClose={() => setOpen(false)}
      url="https://calendly.com/flagsync/15min"
      rootElement={document.getElementById('root')!}
    />
  );
}
